module.exports = __webpack_public_path__ + "static/media/MOSIS Terms and Conditions 01 17 19  Rev 0.dd75e432.pdf";